import { useMicVolume } from "@/hooks/useMicVolume";
import React from "react";

const numBars = 10;

type VolumeLevelProps = {
  volume: number;
  assistantIsSpeaking: boolean;
};

const VolumeLevel = ({ volume, assistantIsSpeaking }: VolumeLevelProps) => {
  const micVolume = useMicVolume();
  const volumeLevel = assistantIsSpeaking ? volume : micVolume;
  const barColour = assistantIsSpeaking ? "bg-green-400" : "bg-red-400";
  return (
    <div className="p-5">
      <div className="text-foreground mb-2">
        <p>Volume Level:</p>
      </div>
      <div className="flex mb-2.5">
        {Array.from({ length: numBars }, (_, i) => (
          <div
            key={i}
            className={`w-5 h-5 m-0.5 rounded-sm ${
              i / numBars < volumeLevel ? barColour : "bg-white"
            }`}
          />
        ))}
      </div>
      <div className="text-foreground">{Math.round(volumeLevel * 10)}</div>
    </div>
  );
};

export default VolumeLevel;
